import { ProjectService } from './../project.service';
import { Component, OnInit } from '@angular/core';
import { Project } from '../project';
import { PlasterService } from '../plaster.service';
import { Plaster } from '../plaster';
// import * as jsPDF from 'jspdf';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { ModalService } from '../modal.service';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-project-summary',
  templateUrl: './project-summary.component.html',
  styleUrls: ['./project-summary.component.sass']
})
export class ProjectSummaryComponent implements OnInit {
  title: string = "DZIĘKUJEMY ZA SKORZYSTANIE Z APLIKACJI!";
  subtitle: string = "Zobacz podsumowanie Twojej pracy z programem. Teraz możesz zapisać swój projekt wraz z kompletem przydatnych informacji o kolorze, rodzaju tynku i potrzebnej ilości oraz adresami najbliższych sklepów, w których kupisz nasze produkty.";
  back_to_edit: string = "/editor"
  use_mosaic: boolean = false;
  project: Project = null;
  plaster: Plaster;
  back_to_main: boolean = false;
  isIOS: boolean = false;

  constructor(private projectService: ProjectService, private plasterService: PlasterService, private modalService: ModalService, private router: Router) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.use_mosaic = this.project.selectedMosaic != null;
    this.plaster = this.plasterService.getKnaufPlaster(this.projectService.getSelectedKnaufPlaster());
    this.isIOS = this.isOS();
  }

  isOS(): boolean {

    var iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()){ return true; }
      }
    }

    return false;
  }

  downloadPdf() {
    var backToMain = this.back_to_main;
    this.closeModal('save-dlg');
    var data = document.getElementById('content');
    var that = this;
    setTimeout(() => {
      html2canvas(data, { y: 0 }).then(canvas => {
        // Few necessary setting options
        document.body.appendChild(canvas)
        var imgWidth = 190;
        var imgHeight = canvas.height * imgWidth / canvas.width + 20;
        const contentDataURL = canvas.toDataURL('image/jpeg')
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
        pdf.addImage(contentDataURL, 'JPEG', 10, 10, imgWidth, imgHeight)
        pdf.save('knauf-projekt.pdf'); // Generated PDF
        document.body.removeChild(canvas);
      });
      if (backToMain) {
        that.router.navigate(['/']);
      }

    }, 500);
    if (!this.isOS())
      saveAs(this.project.projectImageFile, 'knauf-projekt.jpeg');
  }

  downloadJpeg() {
    this.closeModal('save-dlg');
    // saveAs(this.project.projectImageFile, 'knauf-projekt.jpeg');
    var a: HTMLLinkElement = <HTMLLinkElement>document.getElementById('download');
    var b = a.href;
    a.href = this.project.projectImageFile;
    document.getElementById('download').click();
    a.href = b;
  }

  closeModal(id: string) {
    this.modalService.close(id);
    this.back_to_main = false;
  }

  saveClick() {
    this.modalService.open('save-dlg')
  }

  finishClick() {
    this.modalService.open('finish-dlg');
  }

  decline() {
    this.modalService.close('finish-dlg');
    this.router.navigate(['/']);
  }

  accept() {
    this.modalService.close('finish-dlg');
    this.back_to_main = true;
    this.saveClick();
  }
}
